import {
	ROUTES
} from 'common/const.js'

// 懒加载方式加载路由
const Index = () => import('views/index')

const Entity = () => import('views/entity')
const EntityManage = () => import('views/entity/EntityManage')
const EntityVip = () => import('views/entity/EntityVip')

const User = () => import('views/user')
const UserManage = () => import('views/user/UserManage')
const ConsultationRecord = () => import('views/user/ConsultationRecord')
const Message = () => import('views/user/Message')
const WechatManage = () => import('views/user/WechatManage')


const System = () => import('views/system')
const Permission = () => import('views/system/permission')
const MenuManage = () => import('views/system/permission/MenuManage')
const MenuRoleManage = () => import('views/system/permission/MenuRoleManage')
const RoleManage = () => import('views/system/permission/RoleManage')

const Car = () => import('views/car')
const CarManage = () => import('views/car/CarManage')
const CarAdd = () => import('views/car/CarAdd')
const CarType = () => import('views/car/CarType')
const CarVoice = () => import('views/car/CarVoice')
const DataMonitor = () => import('views/car/DataMonitor.vue')
const DataMonitorInfo = () => import('views/car/DataMonitorInfo.vue')
const CarAppManage = () => import('views/car/CarAppManage.vue')
const AlarmManage = () => import('views/car/alarmManage')
const ConsumablesManage = () => import('views/car/consumables')

const Monitor= () => import('views/monitor')
const CarMonitor= () => import('views/monitor/carMonitor.vue')

const Lease= () => import('views/lease')
const Order= () => import('views/lease/order.vue')

const File = () => import('views/file')
const MapFile = () => import('views/file/MapFile')
const RouterFile = () => import('views/file/RouterFile')


const Layout = () => import('components/content/layout')

const Remote = () => import('views/remote')

const Apk = ()  => import('views/apk')
const ApkAdd = () => import('views/apk/apkAdd')
const ApkManage = () => import('views/apk/apkManage')

const Work = () => import('views/work')
const WorkManage = () => import('views/work/workManage')
const WorkMultiManage = () => import('views/work/workMultiManage')

const Data = () => import('views/data')
const DataClear = () => import('views/data/dataClear')

const Report = () => import('views/report')
const ReportAnalysis = () => import('views/report/dataAnalysis')



// 所有的页面，用于生成路由
const asyncRoutes = {
	[ROUTES.index]: {
		path: ROUTES.index,
		name: 'index',
		component: Index
	},
	[ROUTES.entity]: {
		path: ROUTES.entity,
		name: 'entity',
		component: Entity,
		meta: {
		keepAlive: false // 不需要缓存
		
		}
	},
	[ROUTES.entity_manage]: {
		path: ROUTES.entity_manage,
		name: 'entity_manage',
		component: EntityManage,
		meta: {
		keepAlive: false // 不需要缓存
		
		}
	},
	[ROUTES.entity_vip]: {
		path: ROUTES.entity_vip,
		name: 'entity_vip',
		component:EntityVip,
		meta: {
		keepAlive: false // 不需要缓存
		
		}
	},
	[ROUTES.user]: {
		path: ROUTES.user,
		name: 'user',
		component: User
	},
	[ROUTES.user_manage]: {
		path: ROUTES.user_manage,
		name: 'user_manage',
		component: UserManage
	},
	[ROUTES.consultation]:{
		path: ROUTES.consultation,
		name:'consultation',
		component: ConsultationRecord
	},
	[ROUTES.message]:{
		path: ROUTES.message,
		name:'message',
		component: Message
	},
	[ROUTES.wechat_manage]: {
		path: ROUTES.wechat_manage,
		name: 'wechat_manage',
		component: WechatManage
	},
	
	[ROUTES.sys]: {
		path: ROUTES.sys,
		name: 'sys',
		component: System
	},
	[ROUTES.sys_pmsn]: {
		path: ROUTES.sys_pmsn,
		name: 'sys_pmsn',
		component: Permission
	},
	[ROUTES.sys_pmsn_menu]: {
		path: ROUTES.sys_pmsn_menu,
		name: 'sys_pmsn_menu',
		component: MenuManage
	},
	[ROUTES.sys_pmsn_menu_role]: {
		path: ROUTES.sys_pmsn_menu_role,
		name: 'sys_pmsn_menu_role',
		component: MenuRoleManage
	},
	[ROUTES.sys_pmsn_role]: {
		path: ROUTES.sys_pmsn_role,
		name: 'sys_pmsn_role',
		component: RoleManage
	},
	[ROUTES.car]: {
		path: ROUTES.car,
		name: 'car',
		component: Car
	},
	[ROUTES.car_manage]: {
		path: ROUTES.car_manage,
		name: 'car_manage',
		component: CarManage
	},
	[ROUTES.car_add]: {
		path: ROUTES.car_add,
		name: 'car_add',
		component: CarAdd
	},
	[ROUTES.car_type]: {
		path: ROUTES.car_type,
		name: 'car_type',
		component: CarType
	},
	[ROUTES.car_voice]: {
		path: ROUTES.car_voice,
		name: 'car_voice',
		component: CarVoice
	},
	[ROUTES.consumables]: {
		path: ROUTES.consumables,
		name: 'consumables',
		component: ConsumablesManage
	},
	[ROUTES.data_monitor]: {
		path: ROUTES.data_monitor,
		name: 'data_monitor',
		component: DataMonitor,
	},
	[ROUTES.data_monitor_info]: {
		path: ROUTES.data_monitor_info,
		name: 'data_monitor_info',
		component: DataMonitorInfo,
	},
	[ROUTES.car_app_manage]: {
		path: ROUTES.car_app_manage,
		name: 'car_app_manage',
		component: CarAppManage,
	},
	[ROUTES.monitor]: {
		path: ROUTES.monitor,
		name: 'monitor',
		component: Monitor
	},
	[ROUTES.car_monitor]: {
		path: ROUTES.car_monitor,
		name: 'car_monitor',
		component: CarMonitor
	},
	[ROUTES.lease]: {
		path: ROUTES.lease,
		name: 'lease',
		component: Lease
	},
	[ROUTES.order]: {
		path: ROUTES.order,
		name: 'order',
		component: Order
	},
	[ROUTES.file]: {
		path: ROUTES.file,
		name: 'file',
		component: File
	},
	[ROUTES.file_map]: {
		path: ROUTES.file_map,
		name: 'file_map',
		component: MapFile
	},
	[ROUTES.file_router]: {
		path: ROUTES.file_router,
		name: 'file_router',
		component: RouterFile
	},
    [ROUTES.remote]:{
        path: ROUTES.remote,
        name: 'remote',
        component: Remote
    },
	[ROUTES.apk]: {
		path: ROUTES.apk,
		name: 'apk',
		component: Apk
	},
	[ROUTES.apk_add]: {
		path: ROUTES.apk_add,
		name: 'apk_add',
		component: ApkAdd
	},
	[ROUTES.apk_manage]:{
		path:ROUTES.apk_manage,
		name:'apk_manage',
		component:ApkManage,
		meta: {
		keepAlive: false // 不需要缓存
		
		}
	},
	[ROUTES.work]: {
		path: ROUTES.work,
		name: 'work',
		component: Work
	},
	[ROUTES.work_manage]: {
		path: ROUTES.work_manage,
		name: 'work_manage',
		component: WorkManage
	},
	[ROUTES.work_multiManage]: {
		path: ROUTES.work_multiManage,
		name: 'work_multiManage',
		component: WorkMultiManage
	},
	[ROUTES.data]: {
		path: ROUTES.data,
		name: 'data',
		component: Data
	},
	[ROUTES.data_clear]: {
		path: ROUTES.data_clear,
		name: 'data_clear',
		component: DataClear
	},
	[ROUTES.report]: {
		path: ROUTES.report,
		name: 'report',
		component: Report
	},
	[ROUTES.report_analysis]: {
		path: ROUTES.report_analysis,
		name: 'report_analysis',
		component: ReportAnalysis
	},
	[ROUTES.alarm_manage]: {
		path: ROUTES.alarm_manage,
		name: 'alarm_manage',
		component: AlarmManage
	},
	// Layout为可复用组件，需要返回对象，否则会造成多个路由重复
	[ROUTES.layout]() {
		return Layout
	}
}

export default asyncRoutes
